module.exports = __webpack_public_path__ + "static/media/Universitas Airlangga.35061d36.jpg";